function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomJetBathFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-2a.5.5 0 100-1 .5.5 0 000 1zM29 23h1v-2H2v2h1a7 7 0 007 7h12a7 7 0 007-7zm-7 5a5 5 0 005-5H5a5 5 0 005 5h12zM20 12a3 3 0 11-6 0 3 3 0 016 0zm-2 0a1 1 0 11-2 0 1 1 0 012 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.46c0-.156.02-.25.038-.3.016-.044.028-.056.032-.059.004-.003.111-.101.53-.101.118 0 .161.025.17.03.01.006.036.024.072.088.088.155.158.451.158.882h2c0-.57-.08-1.273-.417-1.868C7.2 14.459 6.528 14 5.6 14c-.681 0-1.374.153-1.895.639-.534.499-.705 1.176-.705 1.82V20h2v-3.54z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 17.17V17a3 3 0 10-6 0v.17A3.001 3.001 0 0019 20h2a1 1 0 112 0h2a1 1 0 112 0h2a3.001 3.001 0 00-2-2.83zM24 16a1 1 0 00-1 1v.17c.373.132.712.336 1 .594a2.997 2.997 0 011-.593V17a1 1 0 00-1-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19a1 1 0 00-1 1h-2a3 3 0 116 0h-2a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconRoomJetBathFilled;